<div *ngIf="isLoading">Loading Document List...</div>

<select *ngIf="!isLoading && model && model !== undefined" [compareWith]="byId" class="form-control" name="document" [(ngModel)]="model.document" [required]="required">
  <option *ngFor="let singleDocument of documents" [ngValue]="singleDocument">{{ singleDocument.name }}</option>
</select>

<select *ngIf="!isLoading && (!model || model === undefined)" [compareWith]="byId" class="form-control" name="document" ngModel [required]="required">
  <option *ngFor="let singleDocument of documents" [ngValue]="singleDocument">{{ singleDocument.name }}</option>
</select>
